import React from "react";

const Loader = ({ size = "default", useDots = false }) => {
  const sizeClass = size === "sm" ? "enterprise-loader--sm" : size === "lg" ? "enterprise-loader--lg" : "";
  return (
    <div className="min-h-[200px] flex items-center justify-center w-full py-12">
      {useDots ? (
        <div className="enterprise-loader-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      ) : (
        <div
          className={`enterprise-loader ${sizeClass}`}
          role="progressbar"
          aria-label="Loading"
        />
      )}
    </div>
  );
};

export default Loader;
